import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { ReportsState, LoadLinescores, getLinescoreEntity } from '../store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MatDividerModule } from '@angular/material/divider';
import { LsTableComponent } from '../ls-table/ls-table.component';
import { NgIf, NgFor, NgSwitch, NgSwitchCase, AsyncPipe } from '@angular/common';
import { LinescaleComponent } from 'linescale/linescale.component';

@Component({
    selector: 'ls-linescores',
    templateUrl: './linescores.component.html',
    styleUrls: ['./linescores.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, NgSwitch, NgSwitchCase, LsTableComponent, LinescaleComponent, MatDividerModule, AsyncPipe]
})
export class LinescoresComponent implements OnInit {

    tabData$: Observable<any>;

    constructor(
        private route: ActivatedRoute,
        private store: Store<ReportsState>
    ) { }

    ngOnInit() {
        // do stuff...
        const cacheKey: string = this.route.snapshot.params.cacheKey;
        this.store.dispatch(new LoadLinescores(cacheKey));
        this.tabData$ = this.store.pipe(
            select(getLinescoreEntity),
            tap(stuff => {
                console.log(stuff);

            })
        );
    }

}
